import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { navModule } from './modules/nav';

// Present a single Microsoft/Entra ID sign-in option. The guest provider is
// intentionally not offered here — it's disabled in production anyway (see
// app-config.production.yaml) and access is gated to the SG_Backstage_Users
// group at the Entra app-assignment level. Cloudflare fronts this app for
// TLS/DNS/DDoS, but we don't use Cloudflare Access (Zero Trust) as an auth
// gate, so there is no proxied/edge-JWT sign-in path here — Backstage always
// runs its own interactive login.
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Microsoft',
            message: 'Sign in with your PayRetailers account',
            apiRef: microsoftAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
